exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n[data-v-0407e915] .gl-balance-total-row td { background: #fafafa !important; font-weight: 600;\n}\n", ""]);

// exports
